<template>
  <div class="CaseDiscussion">
    <Tabs :animated="false" name="tab" @on-click="tabChange" v-model="tabName">
      <TabPane
        :label="'进行中(' + caseNum.underWay + ')'"
        tab="tab"
        name="tab_1"
      >
      </TabPane>
      <TabPane
        :label="'已结束(' + caseNum.endWith + ')'"
        tab="tab"
        name="tab_2"
      >
      </TabPane>
      <TabPane
        :label="'随访中(' + caseNum.followUp + ')'"
        tab="tab"
        name="tab_3"
      >
      </TabPane>
    </Tabs>
    <div class="head">
      <span>
        创建时间：
        <DatePicker
          transfer
          type="daterange"
          split-panels
          placeholder="请选择时间"
          v-model="createTime"
        ></DatePicker>
      </span>
      <span>
        医生：
        <Input
          v-model="doctor"
          placeholder="医生姓名"
          style="width: 200px"
          clearable
        />
      </span>
      <span style="margin-right: 24px">
        患者：
        <Input
          v-model="PatientName"
          placeholder="患者姓名"
          style="width: 200px"
          clearable
        />
      </span>
      <Button type="primary" @click="searchConsult(1, true)">查询</Button>
      <Button
        v-if="stroge.DocType ? stroge.DocType == '基层' : false"
        style="margin-left: 15px"
        type="primary"
        @click="newCase"
        >新建案例</Button
      >
      <!-- v-if="stroge.DocType ? stroge.DocType == '基层' : false" -->
    </div>
    <Divider style="margin: 15px 0 0" />
    <div class="content">
      <Row>
        <Col span="8" v-for="(item, index) in caseList" :key="index">
          <Card style="width: 80%">
            <div class="box">
              <div
                :class="{
                  tag: true,
                  tag1: item.Status == 1,
                  tag2: item.Status == 2,
                  tag3: item.Status == 3,
                }"
              >
                {{
                  item.Status == 1
                    ? "进行中"
                    : item.Status == 2
                    ? "已结束"
                    : "随访中"
                }}
              </div>
              <div class="patientInfo">
                <img
                  :src="
                    item.Gender == '男'
                      ? require('../assets/boy.png')
                      : require('../assets/girl.png')
                  "
                  alt=""
                  style="border-radius: 50%"
                />
                <div class="info">
                  <div>
                    <span class="name">{{ item.PatientName }}</span>
                    <span>{{ item.Gender }}</span>
                    <span>{{ item.Age }}岁</span>
                  </div>
                  <div>
                    创建时间：{{
                      item.CrtDate ? item.CrtDate.replace("T", " ") : ""
                    }}
                  </div>
                  <div>主诉：{{ item.Complaint }}</div>
                </div>
              </div>
              <div class="btn_box" @click="lookInfo(item.ID)">查看</div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
    <div class="pagination">
      <Page
        v-if="parseInt(pageTotal) > 0"
        :total="pageTotal"
        show-sizer
        show-elevator
        show-total
        transfer
        :current="page"
        :page-size="pageSize"
        :page-size-opts="pageSizeOpts"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
      />
    </div>
  </div>
</template>

<script>
import {
  Button,
  Divider,
  DatePicker,
  Select,
  Option,
  Input,
  Card,
  Row,
  Col,
  Page,
  Tabs,
  TabPane,
} from "view-design";
import dayjs from "dayjs";
import Request from "../utils/request";
import Config from "../config/index";
const getCaseNum = Config.SXG_baseUrl + "/api/casemanager/GetCaseNum"; //根据状态获取数量
const searchCase = Config.SXG_baseUrl + "/api/casemanager/GetCaseListByPage"; //查询案例
const getTeam = Config.SXG_baseUrl + "/api/casemanager/GetCenterList"; //获取团队名称列表
export default {
  components: {
    Button,
    Divider,
    DatePicker,
    Select,
    Option,
    Input,
    Card,
    Row,
    Col,
    Page,
    Tabs,
    TabPane,
  },
  data() {
    return {
      isJoin: "",
      stroge: JSON.parse(localStorage.getItem("Role")),
      PatientName: "", //患者姓名
      createTime: ["", ""],
      caseNum: {
        underWay: 10, //进行中
        endWith: 0, //已结束
        followUp: 0, //随访中
      },
      tabName: "tab_1",
      // state:'',
      doctor: "",
      caseList: [], //进行中案例
      pageTotal: 1,
      pageSize: 9,
      page: 1,
      pageSizeOpts: [9, 18, 27, 36, 45, 54],
    };
  },
  methods: {
    /* 点击查看 */
    lookInfo(id) {
      this.$router.push(`/HomePage/CaseDetail/${id}/1`);
    },
    /* 分页改变事件 */
    pageChange(page) {
      //this.getListData(page)
      this.page = page;
      this.searchConsult(page);
    },
    /* 分页总数发生改变 */
    pageSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.searchConsult(1);
      //this.getListData(1);
    },
    //tab切换
    tabChange(name) {
      //console.log(this.tabName,88888888888)
      this.tabName = name;
      this.page = 1;
      this.caseList = [];
      this.searchConsult(1);
    },
    /* 根据状态获取数量 */
    getCaseList() {
      let obj = {};
      if (this.stroge.RoleID == 1 && this.stroge.DocType == "中心") {
        obj = {
          CenterID: this.stroge.CenterID,
        };
      }
      if (this.stroge.RoleID == 1 && this.stroge.DocType == "基层") {
        obj = {
          UserJid: this.stroge.UserJid,
        };
      } else if (this.stroge.RoleID == 2) {
        obj = {
          CenterID: this.stroge.CenterID,
        };
      } else if (this.stroge.RoleID == 3) {
        obj = {};
      }
      Request.getRequest(getCaseNum, obj).then((res) => {
        // console.log(res, "根据状态获取案例数量");
        if (res.code == 200) {
          this.caseNum.underWay = res.data[0][1];
          this.caseNum.endWith = res.data[0][2];
          this.caseNum.followUp = res.data[0][3];
        } else {
          this.$Message.info(res.message);
        }
      });
    },
    /* 点击查询 */
    searchConsult(page, searchFlag = false) {
      let obj = {};
      if (this.stroge.RoleID == 1 && this.stroge.DocType == "中心") {
        obj = {
          CenterID: this.stroge.CenterID,
          pageNum: page,
          pageSize: this.pageSize,
          Status: this.tabName == "tab_1" ? 1 : this.tabName == "tab_2" ? 2 : 3,
          startDate: searchFlag
            ? this.createTime[0]
              ? dayjs(this.createTime[0]).format("YYYY-MM-DD")
              : ""
            : "",
          endDate: searchFlag
            ? this.createTime[1]
              ? dayjs(this.createTime[1]).format("YYYY-MM-DD")
              : ""
            : "",
          DocName: searchFlag ? this.doctor : "",
          PatientName: searchFlag ? this.PatientName : "",
        };
      } else if (this.stroge.RoleID == 1 && this.stroge.DocType == "基层") {
        obj = {
          UserJid: this.stroge.UserJid,
          pageNum: page,
          pageSize: this.pageSize,
          Status: this.tabName == "tab_1" ? 1 : this.tabName == "tab_2" ? 2 : 3,
          startDate: searchFlag
            ? this.createTime[0]
              ? dayjs(this.createTime[0]).format("YYYY-MM-DD")
              : ""
            : "",
          endDate: searchFlag
            ? this.createTime[1]
              ? dayjs(this.createTime[1]).format("YYYY-MM-DD")
              : ""
            : "",
          DocName: searchFlag ? this.doctor : "",
          PatientName: searchFlag ? this.PatientName : "",
        };
      } else if (this.stroge.RoleID == 2) {
        obj = {
          CenterID: this.stroge.CenterID,
          pageNum: page,
          pageSize: this.pageSize,
          Status: this.tabName == "tab_1" ? 1 : this.tabName == "tab_2" ? 2 : 3,
          startDate: searchFlag
            ? this.createTime[0]
              ? dayjs(this.createTime[0]).format("YYYY-MM-DD")
              : ""
            : "",
          endDate: searchFlag
            ? this.createTime[1]
              ? dayjs(this.createTime[1]).format("YYYY-MM-DD")
              : ""
            : "",
          DocName: searchFlag ? this.doctor : "",
          PatientName: searchFlag ? this.PatientName : "",
        };
      } else if (this.stroge.RoleID == 3) {
        obj = {
          pageNum: page,
          pageSize: this.pageSize,
          Status: this.tabName == "tab_1" ? 1 : this.tabName == "tab_2" ? 2 : 3,
          startDate: searchFlag
            ? this.createTime[0]
              ? dayjs(this.createTime[0]).format("YYYY-MM-DD")
              : ""
            : "",
          endDate: searchFlag
            ? this.createTime[1]
              ? dayjs(this.createTime[1]).format("YYYY-MM-DD")
              : ""
            : "",
          DocName: searchFlag ? this.doctor : "",
          PatientName: searchFlag ? this.PatientName : "",
        };
      }
      Request.getRequest(searchCase, obj).then((res) => {
        console.log(res, 22222222222222);
        this.caseList = res.data.Record;
        this.pageTotal = parseInt(res.data.count);
        // console.log(this.caseList)
      });
    },
    //新建案例
    newCase() {
        if (this.isJoin) {
            return this.$Message.info("您还没加入团队，暂不能发起案例");
      }
      this.$store.commit({
        type: "edit",
        payload: {
          type: 0,
        },
      });
      
      this.$router.push("/HomePage/NewCase");
    },
    //获取团队
    getTeam() {
      Request.getRequest(getTeam, {
        tablename: "CenterHospital",
        fields: "ID CenterID,Team",
        UserJid: this.stroge.UserJid,
      }).then((res) => {
        if (res.code == 200) {
          if (!res.data.length) {
            this.isJoin = true;
          }
        }
      });
    },
  },

  created() {
    this.$emit("funChangeTitle", "案例讨论", "2-1");
    this.tabName = this.$route.params.tab;
  },
  mounted() {
    this.getCaseList();
    this.searchConsult(1);
    this.getTeam();
  },
};
</script>

<style lang="less">
.CaseDiscussion {
  position: relative;
  padding: 20px 30px 10px;
  height: 100%;
  //background: #1890FF;
  .content {
    //height: 100%;
    //background: #1890FF;
    padding-bottom: 20px;
    margin: 20px;
    .ivu-card {
      .ivu-card-body {
        padding: 0px !important;
      }
    }
    .box {
      //position: relative;
      .tag {
        //background: chartreuse;
        position: absolute;
        right: 15px;
        top: 15px;
        color: #fff;
        padding: 0 10px;
        border-radius: 15px;
      }
      .tag1 {
        background: #28d094;
      }
      .tag2 {
        background: #c7c7c7;
      }
      .tag3 {
        background: #1890ff;
      }
      .patientInfo {
        display: flex;
        margin: 15px 0 0 20px;
        img {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .info {
          height: 130px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          div {
            .name {
              font-size: 20px;
              font-weight: 700;
              color: #333;
            }
            span:nth-child(2) {
              margin: 0 15px;
            }
            color: #a1a1a1;
          }
        }
      }
      .btn_box {
        cursor: pointer;
        background: #f7f9fa;
        border-top: 1px solid #eee;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #28d094;
      }
    }
  }
  .ivu-col {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .pagination {
    position: fixed;
    bottom: 30px;
    right: 70px;
    // display: flex;
    // justify-content: flex-end;
    // margin: 12px 0 0;
  }
}
</style>
